import React from 'react';
import styled, { css } from 'styled-components';

type TagStatus = 'normal' | 'info' | 'warning' | 'success' | 'error';

type TagProps = {
    status: TagStatus;
    children: React.ReactNode;

    className?: string;
};

type TagColor = {
    color: string;
    transparent: string;
};

const COLOR_BY_STATUS_MAP: Record<TagStatus, TagColor> = {
    normal: {
        color: 'rgba(0, 137, 123, 1)',
        transparent: 'rgba(0, 137, 123, 0.08)',
    },
    info: {
        color: 'rgba(9, 109, 217, 1)',
        transparent: 'rgba(9, 109, 217, 0.08)',
    },
    warning: {
        color: 'rgba(255, 138, 0, 1)',
        transparent: 'rgba(255, 138, 0, 0.08)',
    },
    success: {
        color: 'rgba(82, 196, 26, 1)',
        transparent: 'rgba(82, 196, 26, 0.08)',
    },
    error: {
        color: 'rgba(207, 19, 34, 1)',
        transparent: 'rgba(207, 19, 34, 0.08)',
    },
};

const Tag = (props: TagProps): React.ReactElement => {
    const { status, className, children } = props;

    return (
        <Root status={status} className={className}>
            <span>{children}</span>
        </Root>
    );
};

const Root = styled.span<Pick<TagProps, 'status'>>`
    display: inline-flex;
    height: auto;
    padding: 0 7px;
    margin: 0;
    font-size: 1.2rem;
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 1px solid transparent;
    border-radius: 4px;

    span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    ${p =>
        COLOR_BY_STATUS_MAP[p.status] &&
        css`
            color: ${COLOR_BY_STATUS_MAP[p.status].color};
            background: ${COLOR_BY_STATUS_MAP[p.status].transparent};
            border-color: ${COLOR_BY_STATUS_MAP[p.status].color};
        `}
`;

export { Tag };
